<template>
  <div id="_documents">
    <div class="documents-container">
      <info-block :title="$getModuleTitle(currentEvent.modules, 'Documents')" :desc="$t('networking.description')" :button="null" :url="null">
        <template slot="input">
          <div class="document-header" :style="currentDocumentCategories.length != 0 ? 'grid-template-columns: 2fr 1fr' : 'grid-template-columns: 1fr;'">
            <div class="document-search">
              <el-input v-model="searchTerm" :placeholder="$t('event.document.search_placeholder')" :loading="loading == 'documents'" :suffix-icon="loading == 'documents' ? 'el-icon-loading' : 'el-icon-search'" @clear="searchTerm = null" clearable></el-input>
            </div>
            <div class="document-select" v-if="currentDocumentCategories.length != 0">
              <el-select v-model="categoryId" @clear="categoryId = null" :placeholder="$t('event.document.all')" clearable>
                <el-option :key="index" :label="category.title" :value="category.id" v-for="(category, index) in currentDocumentCategories">
                  <template>
                    <i class="fas fa-circle" :style="'color:' + category.color" style="margin-right:4px"></i>
                    <span>{{ category.title }}</span>
                  </template>
                </el-option>
              </el-select>
            </div>
          </div>
        </template>
      </info-block>
      <Nodata :title="$getModuleTitle(currentEvent.modules, 'Documents')" :description="categoryId == null && searchTerm == null && searchTerm != '' ? $t('contentNotFound') : $t('contentFilterNotFound')" anim="holacon-document-lottie" :loading="loading == 'documents'" v-if="currentDocuments.length == 0" :button="$t('refresh')" @btnClick="refresh()" />

      <div class="documents-list">
        <div class="document-item" v-for="doc in currentDocuments" :key="doc.id" @click="save(doc)">
          <div class="document-avatar">
            <img :src="'/static/icons/' + getExtension(doc.image) + '.svg'" alt />
            <md-tooltip md-direction="right" md-delay="100" v-if="currentDocumentCategories.some(k => k.id == doc.categoryID)"> {{ currentDocumentCategories.find(k => k.id == doc.categoryID).title }} </md-tooltip>
          </div>
          <div class="document-title">
            <p>
              {{ doc.title }} <strong>.{{ getExtension(doc.image) }}</strong>
            </p>
            <p v-if="currentDocumentCategories.some(k => k.id == doc.categoryID)">{{ currentDocumentCategories.find(k => k.id == doc.categoryID).title }}</p>
          </div>
          <div class="document-operations">
            <md-button class="md-icon-button md-raised download-button">
              <i class="fa fa-download"></i>
            </md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfoBlock from "../../modules/InfoBlock.vue";
import { saveAs } from "file-saver";
export default {
  name: "DocumentsComponent",
  components: { saveAs, InfoBlock },
  data() {
    return {
      categoryId: null,
      searchTerm: null,
      loading: false,
      timeout: null
    };
  },
  methods: {
    getExtension(file) {
      var parts = file.split(".");
      return parts[parts.length - 1];
    },
    save(file) {
      window.open(file.image, "_blank");
    },
    searchFilter() {
      this.loading = "documents";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getDocuments", { searchTerm: this.searchTerm, id: this.currentEvent.id, route: false });
        this.loading = false;
      }, 1000);
    },
    async refresh() {
      this.loading = "documents";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.searchTerm = null;
        this.categoryId = null;
        await this.$store.dispatch("getDocuments", { searchTerm: null, id: this.currentEvent.id, route: false });
        this.loading = false;
      }, 500);
    }
  },
  async mounted() {
    this.$nextTick(async () => {
      await this.$store.dispatch("getDocuments", { id: this.currentEvent.id, route: false });
      await this.$store.dispatch("getDocumentCategories", { id: this.currentEvent.id, route: false });
    });
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentDocuments() {
      if (this.categoryId != null && this.categoryId != "") {
        return this.$store.getters.getDocuments.filter(x => x.categoryID == this.categoryId);
      } else {
        return this.$store.getters.getDocuments;
      }
    },
    currentDocumentCategories() {
      return this.$store.getters.getDocumentCategories;
    }
  },
  watch: {
    searchTerm: async function() {
      await this.searchFilter();
    }
  }
};
</script>

<style lang="less">
#_documents {
  display: flex;
  flex-direction: column;
  width: 100%;

  .documents-container {
    display: block;
    width: inherit;
    margin: 0 auto;

    .document-header {
      width: 100%;
      display: grid;
      grid-template-columns: 2fr 1fr;
      grid-gap: 10px;

      .document-search {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        position: relative;

        input {
          width: 100% !important;
        }
      }

      .document-select {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        position: relative;

        .el-select {
          width: 100% !important;
        }
      }
    }

    .documents-list {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 8px;
      .document-item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background: white;
        border-radius: 12px;
        box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
        padding: 6px 12px;
        &:hover {
          background-color: #fbfbfb;
          transition: all 0.3s ease 0s;
        }
        .document-avatar {
          width: 45px;
          height: 45px;
          cursor: pointer;

          img {
            padding: 8px;
          }
        }

        .document-title {
          margin-left: 12px;
          width: ~"calc(100% - 110px)";
          cursor: pointer;

          p {
            margin: 0px;
            padding: 0px;
            font-weight: 400;
            color: #292f3b;
            font-size: 16px;

            &:last-child {
              color: #8c929c;
              font-size: 13px;
            }

            strong {
              font-weight: 600;
            }
          }
        }

        .document-operations {
          display: block;

          .download-button {
            box-shadow: unset;

            i {
              color: #8c929c;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  #_documents {
    padding: 0px;

    .documents-container {
      padding: 0px 12px;

      .document-header {
        grid-template-columns: 1fr !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/Documents.vue